
import { Component, Vue, Prop } from 'vue-property-decorator';
import { OrderComplainModel } from '@/models/order-complain';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class OrderComplain extends Vue {
    @Prop({default: []})
    private orderComplains!: OrderComplainModel[];

    private async viewComplain(complain: any) {
        let routeData = this.$router.resolve({ name: 'detail-order-complain', params: { orderId: complain.orderId, complainId: complain.id } });
        if (complain.orderType == APP_CONFIG.ORDER_TYPE.deposit) {
            routeData = this.$router.resolve({ name: 'detail-deposit-complain', params: { orderId: complain.orderId, complainId: complain.id, orderType: '2' } });
        }
        window.open(routeData.href, '_blank');
    }
}
